export default {"src":"/_next/static/media/user-profile-white.a58b5f3f.svg","height":18,"width":16};